<template>
  <v-row dense justify="center">
    <v-col v-for="card in cards" :key="card.ref" cols="12" sm="6" md="4">
      <v-card-charts-dashboard
        :title="card.title"
        :ref="card.highchartsOptionsAndRef"
        :chart-ref="card.highchartsOptionsAndRef"
        :options="card.options"
        :deepCopyOnUpdate="card.deepCopyOnUpdate"
        :isLoading="card.loading"
      />
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "DashboardLnoVisaoAneelKpis",
  components: {
    VCardChartsDashboard: () =>
      import("@/components/base/VCardChartsDashboard.vue"),
  },
  props: {
    cards: {
      type: Array,
      default: () => [],
    },
  },
};
</script>

<style scoped></style>
